"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestProgressionMilestoneToJSON = exports.QuestProgressionMilestoneFromJSONTyped = exports.QuestProgressionMilestoneFromJSON = void 0;
var runtime_1 = require("../runtime");
function QuestProgressionMilestoneFromJSON(json) {
    return QuestProgressionMilestoneFromJSONTyped(json, false);
}
exports.QuestProgressionMilestoneFromJSON = QuestProgressionMilestoneFromJSON;
function QuestProgressionMilestoneFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isComplete': json['isComplete'],
        'claimedAt': !(0, runtime_1.exists)(json, 'claimedAt') ? undefined : json['claimedAt'],
        'amount': json['amount'],
        'sessionAmount': !(0, runtime_1.exists)(json, 'sessionAmount') ? undefined : json['sessionAmount'],
    };
}
exports.QuestProgressionMilestoneFromJSONTyped = QuestProgressionMilestoneFromJSONTyped;
function QuestProgressionMilestoneToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isComplete': value.isComplete,
        'claimedAt': value.claimedAt,
        'amount': value.amount,
        'sessionAmount': value.sessionAmount,
    };
}
exports.QuestProgressionMilestoneToJSON = QuestProgressionMilestoneToJSON;
